export const ECLIPSE_OVERLAP_GLSL = `const float STAR_LIGHT_RADIUS = 0.085;

float circleOverlapFraction(
  float sourceRadius,
  float occluderRadius,
  float separation
) {
  if (separation >= sourceRadius + occluderRadius) return 0.0;
  if (separation <= abs(sourceRadius - occluderRadius)) {
    return occluderRadius >= sourceRadius
      ? 1.0
      : (occluderRadius * occluderRadius) /
        max(0.00000001, sourceRadius * sourceRadius);
  }
  float safeSeparation = max(0.00000001, separation);
  float sourceProjection =
    (safeSeparation * safeSeparation + sourceRadius * sourceRadius -
      occluderRadius * occluderRadius) /
    (2.0 * safeSeparation);
  float occluderProjection = safeSeparation - sourceProjection;
  float chordHalf = sqrt(max(
    0.0,
    sourceRadius * sourceRadius - sourceProjection * sourceProjection
  ));
  float overlapArea =
    sourceRadius * sourceRadius * acos(clamp(sourceProjection / sourceRadius, -1.0, 1.0)) +
    occluderRadius * occluderRadius * acos(clamp(occluderProjection / occluderRadius, -1.0, 1.0)) -
    safeSeparation * chordHalf;
  return clamp(
    overlapArea / max(0.00000001, 3.14159265359 * sourceRadius * sourceRadius),
    0.0,
    1.0
  );
}

`;
